// Auto-generated by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated on every build/deploy. Gitignored.
const BUILD_INFO = {
  "sha": "1f20458ef5023027005f3ef82d6282b5b281a506",
  "shaShort": "1f20458",
  "branch": "main",
  "time": "2026-11-05T05:47:55.747Z"
};

module.exports = BUILD_INFO;
module.exports.default = BUILD_INFO;
